import React from "react";
import InstructorNotification from "../../../components/Notification/InstructorNotification";
import CertificatesApprovalsTable from "../../../components/CertificatesApprovalsTable/CertificatesApprovalsTable";
import {
  getAllCertificateByInstructorAPI,
  instructorApprovedCertificateAPI,
  instructorRejectCertificateAPI,
} from "../../../redux/features/intructorSlice";

const CertificateRequests = () => {
  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3">
            Certificate Requests
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <InstructorNotification />
          </div>
        </div>
      </div>
      <div>
        <CertificatesApprovalsTable
          fetchAPI={getAllCertificateByInstructorAPI}
          approveAPI={instructorApprovedCertificateAPI}
          rejectAPI={instructorRejectCertificateAPI}
        />
      </div>
    </>
  );
};

export default CertificateRequests;
